import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useWizard } from 'use-wizard';

import { queryParamsModule } from '@/modules/queryParams';

import { OnboardingProvider } from '../../context';
import { OnboardingParamsTool } from '../../utils/paramsTool';

import { layoutSteps } from './constants';
import { LayoutDataKeyType, LayoutDataType } from './types';

const stepsKeys = Object.keys(layoutSteps);

const LayoutDefault: React.FC = () => {
  const [step, wizard] = useWizard(stepsKeys);

  React.useEffect(() => {
    const stepFromParams = OnboardingParamsTool.getParam(
      'step',
    ) as LayoutDataKeyType;

    if (stepFromParams && stepFromParams in layoutSteps) {
      const stepIndex = stepsKeys.indexOf(stepFromParams);
      if (stepIndex === 0) return;

      const prevSteps = stepsKeys.slice(0, stepIndex);

      wizard.history.push(...prevSteps, stepFromParams);
      wizard.goToStep(stepFromParams);
    } else {
      wizard.goToStep('preferences');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const form = useForm<LayoutDataType>({
    defaultValues: {
      name: queryParamsModule.getParam<LayoutDataKeyType>('name') || '',
      categories:
        queryParamsModule.getParamsList<LayoutDataKeyType>('categories') || [],
      preloadCategories: [],
      characters: [],
      interests:
        queryParamsModule.getParamsList<LayoutDataKeyType>('interests') || [],
      ai_characteristic:
        queryParamsModule.getParam<LayoutDataKeyType>('ai_characteristic') ||
        'Neutral',
      email: '',
      topics: queryParamsModule.getParam<LayoutDataKeyType>('topics') || '',
      loneliness:
        queryParamsModule.getParam<LayoutDataKeyType>('loneliness') || null,
      createdUser: false,
    },
  });

  const StepComponent = layoutSteps[step as keyof typeof layoutSteps];

  return (
    <OnboardingProvider wizard={wizard} steps={layoutSteps}>
      <FormProvider {...form}>
        <StepComponent />
      </FormProvider>
    </OnboardingProvider>
  );
};

export default LayoutDefault;
